import classNames from "classnames"
import styles from "./Input.module.scss"

const Input = ({
  autoFocus,
  className,
  disableAutocomplete,
  maxLength,
  name,
  onChange,
  onInput,
  onKeyDown,
  onKeyUp,
  placeholder,
  tabIndex,
  type,
  value,
}) => {
  return (
    <input
      autoFocus={autoFocus}
      className={classNames(styles.input, className)}
      autoComplete={disableAutocomplete ? "off" : "on"}
      maxLength={maxLength}
      name={name}
      onChange={(e) => onChange && onChange(e)}
      onInput={(e) => onInput && onInput(e)}
      onKeyDown={(e) => onKeyDown && onKeyDown(e)}
      onKeyUp={(e) => onKeyUp && onKeyUp(e)}
      placeholder={placeholder}
      tabIndex={tabIndex}
      type={type}
      value={value}
    />
  )
}

export default Input
